/* eslint-disable react-hooks/exhaustive-deps */
import { RootState } from "@base/store";
import Button from "@components/atoms/button";
import { homeActions } from "@components/features/home/home.slice";
import { profileActions } from "@components/features/profile/profile.slice";
import Layout from "@components/molecules/layout";
import { auth } from "@config/firebase/firbaseConfig";
import theme from "@config/theme";
import { IconButton } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useAuthState, useUpdateProfile } from "react-firebase-hooks/auth";
import { ConnectedProps, connect, useSelector } from "react-redux";

import { LoaderSnackbarWrapperActions } from "../LoaderSnackbarWrapper/LoaderSnackbarWrapper.slice";
import {
  ActionsWrapper,
  Avatar,
  AvatarWrapper,
  Content,
  HeaderTitle,
  Typography,
  TypographyWrapper,
} from "./profilePhoto.styled";
import { ProfilePhotoProps } from "./profilePhoto.type";

type ReduxProps = ConnectedProps<typeof connector>;

const ProfilePhoto = ({
  onSkip,
  authState,
  setAlert,
  setLoader,
  setUser,
  uploadProfileImage,
}: ProfilePhotoProps & ReduxProps) => {
  const inputFile = useRef<HTMLInputElement | null>(null);

  const user = useSelector((state: RootState) => state.user.user);
  const currentUser = localStorage.getItem("currentUser");

  const [updateProfile, updating, error] = useUpdateProfile(auth);
  const [userAuth, loadingAuth, errorAuth] = useAuthState(auth);

  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  // const handleSubmit = async () => {
  //   if (selectedFile) {
  //     const success = await updateProfile({
  //       photoURL: URL.createObjectURL(selectedFile),
  //     });
  //     if (success) {
  //       if (loadingAuth === false) {
  //         if (userAuth) {
  //           setUser({
  //             profileImg: userAuth?.photoURL || "",
  //             isLoading: false,
  //           });
  //           setAlert({
  //             alert: {
  //               isVisible: true,
  //               message: `Profile Updated Successfully`,
  //               type: "success",
  //             },
  //           });
  //           authState();
  //         } else {
  //           setUser({
  //             profileImg: "",
  //             isLoading: false,
  //           });
  //         }
  //       }
  //     }
  //   }
  // };

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      setSelectedFile(files[0]);
    }
  };

  const onButtonClick = () => {
    // `current` points to the mounted file input element, if available
    inputFile.current?.click();
  };

  const stringAvatar = (name: string) => {
    return {
      children: `${name?.split(" ")[0][0]?.toUpperCase()}${name
        ?.split(" ")[1][0]
        ?.toUpperCase()}`,
    };
  };

  const uploadProfile = async (formData: any) => {
    const response = await uploadProfileImage(formData);
    setUser({
      profileImg: response?.payload?.profile_url,
    });
    if (currentUser) {
      const retrievedUser = JSON.parse(currentUser);
      const newUser = {
        ...retrievedUser,
        profileImg: response?.payload?.profile_url,
      };
      localStorage.setItem("currentUser", JSON.stringify(newUser));
    }
  };

  useEffect(() => {
    if (selectedFile) {
      let formData = new FormData();
      formData.append("image", selectedFile);
      uploadProfile(formData);
    }
  }, [selectedFile]);

  useEffect(() => {
    setLoader({
      loader: updating,
      isBlankLoader: false,
    });

    if (errorAuth) {
      setUser({
        email: undefined,
        isLoading: false,
      });
      setAlert({
        alert: {
          isVisible: !!errorAuth,
          message: errorAuth?.message,
          type: "error",
        },
      });
    }
    if (error) {
      setAlert({
        alert: {
          isVisible: !!error,
          message: error?.message,
          type: "error",
        },
      });
    }
    return () => {
      setLoader({
        loader: false,
        isBlankLoader: false,
      });
    };
  }, [updating, error, setAlert, errorAuth, setLoader, setUser]);

  return (
    <Layout
      isLayout
      HeaderChildren={<HeaderTitle>Set profile picture</HeaderTitle>}
      CardChildren={<></>}
    >
      <Content>
        <TypographyWrapper>
          <Typography>
            Setting a profile picture makes it easier for people to recognise
            who you are.
          </Typography>

          <Typography>You can set this up later too.</Typography>
        </TypographyWrapper>
        <AvatarWrapper>
          <IconButton onClick={onButtonClick}>
            <input
              type="file"
              id="file"
              ref={inputFile}
              style={{ display: "none" }}
              onChange={onFileChange}
            />
            {selectedFile ? (
              <Avatar
                alt="user Photo"
                src={URL.createObjectURL(selectedFile)}
                {...stringAvatar(`${user?.firstName} ${user?.lastName}`)}
              />
            ) : (
              <Avatar
                alt="user Photo"
                {...stringAvatar(`${user?.firstName} ${user?.lastName}`)}
              />
            )}
          </IconButton>
        </AvatarWrapper>
        <ActionsWrapper>
          <div>
            <Button
              textColor={theme.palette.primary.main}
              variant="text"
              color="primary"
              onClick={onSkip}
              type="button"
              text="Skip"
            />
          </div>
        </ActionsWrapper>
      </Content>
    </Layout>
  );
};

const mapDispatchToProps = {
  setLoader: LoaderSnackbarWrapperActions.setGlobalAppearances,
  setAlert: LoaderSnackbarWrapperActions.setGlobalAppearances,
  setUser: homeActions.setUser,
  uploadProfileImage: profileActions.uploadProfileImage,
};

const connector = connect(undefined, mapDispatchToProps);
const ProfilePhotoRedux = connector(ProfilePhoto);

export { ProfilePhotoRedux as ProfilePhoto };
